'use client';

import { IOC } from '@/ioc/index';
import { createProvider } from '@/src/shared/utils/zustand';

import { SendContactFormInputModel } from '../../domain/models/send-contact-form-input-model';
import { SendContactFormResultViewModel } from '../view-models/send-contact-form-result.viewModel';

import type ContactFormData from '../view-models/contact-form-data';
import type SendContactFormProviderState from '../view-models/send-contact-form-provider-state';
import type { PropsWithChildren } from 'react';

export const useSendContactFormProvider = createProvider<SendContactFormProviderState>(
  () => (set) => ({
    isLoading: false,
    result: null,
    sendContactForm: async (formData: ContactFormData) => {
      const useCase = await IOC.gather('SendContactFormUseCase');
      const input = new SendContactFormInputModel(formData);

      try {
        set({ isLoading: true });
        const result = await useCase.execute(input);
        set({ result: SendContactFormResultViewModel.presenter(result) });
      } catch (error) {
        throw error;
      } finally {
        set({ isLoading: false });
      }
    }
  })
);

export default function SendContactFormProvider(props: PropsWithChildren) {
  return <useSendContactFormProvider.State>{props.children}</useSendContactFormProvider.State>;
}
